import { PrimaryFunction } from './primary-function';
import { IndustrialCodeType } from './industrial-code-type';

export class TypeOfPrimaryFunctionOption {
  typeOfPrimaryFunctionOptionId: number;
  name: string;
  primaryFunction?: PrimaryFunction;
  codeTypes?: IndustrialCodeType[];
}
